/************
 -- General
 ************/

// localized
const productPage = document.querySelector('#product');

// Check if we're on a product page
if (!productPage) {
    console.warn('Product page element not found');
    // Exit early if not on product page
} else {
    // quantity
    let quantity = 1;

    // ATC button
    const productATCButton = productPage.querySelector('#productATC');

// wait for load and check if product has been saved
document.addEventListener("DOMContentLoaded", async () => {
    // check if product is in wishlist
    const wishlist = await getWishList();
    productPage.querySelectorAll('.wishlistAdd').forEach(el => {
        const handle = el.dataset.handle;
        if (wishlist.includes(handle)) el.classList.add("active");
    })
})

/**********************
 -- Product Announcement
 **********************/

// close announcement bar
productPage.querySelector('#productAnnouncementButton')?.addEventListener('click', function () {
    this.parentElement.remove();
});

/******************
 -- Product Swiper
 ******************/

// Declare productImages in broader scope
let productImages;

setTimeout(function () {
    const swiperContainer = document.querySelector(".productSwiper_swiper #productSwiper");

if (swiperContainer) {
    productImages = new Swiper(".productSwiper_swiper #productSwiper", {
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        zoom: {
            maxRatio: 3,
            toggle: false
        },
        on: {
            slideChange: function () {
                // if overlay is active, remove
                document.querySelector('#productSwiperImageOverlay').classList.remove('active');
                document.querySelectorAll('.productSwiperPlay.active')?.forEach(async active => {
                    active.classList.remove('active');
                    await active.querySelector('video').pause();
                })
                // change over active class
                document.querySelectorAll("#productThumbnails .productThumbnailItem.active").forEach(el => el.classList.remove("active"));
                const slideGroup = document.querySelectorAll("#productThumbnails .productThumbnailItem");
                slideGroup[this.activeIndex]?.classList.add("active");
            }
        }
    });

// thumbnail images for swiper
productPage.querySelectorAll(".productThumbnail").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this.parentElement);
        // change active slide
        if (productImages && typeof productImages.slideTo === 'function') {
            productImages.slideTo(index);
        }
    });
})
}else{
 // setup product swiper
productImages = new Swiper("#productSwiper", {
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        zoom: {
            maxRatio: 3,
            toggle: false
        },
        on: {
            slideChange: function () {
                // if overlay is active, remove
                document.querySelector('#productSwiperImageOverlay').classList.remove('active');
                document.querySelectorAll('.productSwiperPlay.active')?.forEach(async active => {
                    active.classList.remove('active');
                    await active.querySelector('video').pause();
                })
                // change over active class
                document.querySelectorAll("#productThumbnails .productThumbnailItem.active").forEach(el => el.classList.remove("active"));
                 document.querySelectorAll("#productThumbnails .productThumbnailItem.matched-variant-thumb.activeess").forEach(el => el.classList.remove("activeess"));
                const slideGroup = document.querySelectorAll("#productThumbnails .productThumbnailItem");
                slideGroup[this.activeIndex]?.classList.add("active");
                const thumbnails = document.querySelectorAll("#productThumbnails .productThumbnailItem.matched-variant-thumb");
                const nextThumbnail = thumbnails[this.activeIndex - 1];
                nextThumbnail.classList.add("activeess");
            }
        }
    });

// thumbnail images for swiper
// productPage.querySelectorAll(".productThumbnail").forEach(function (element) {
//     element.addEventListener("click", function () {
//         // determine index
//         let index = getElIndex(this.parentElement);
//         // change active slide
//         productImages.slideTo(index);
//     });
// });
productPage.querySelectorAll(".productThumbnail").forEach(function (element) {
element.addEventListener("click", function () {
  const matchedThumb = this.closest(".matched-variant-thumb");
    if (matchedThumb) {
      const matchedThumbs = Array.from(document.querySelectorAll(".matched-variant-thumb"));
      const index = matchedThumbs.indexOf(matchedThumb) + 1;
      if (productImages && typeof productImages.slideTo === 'function') {
        productImages.slideTo(index);
      }
    }else{
       if (productImages && typeof productImages.slideTo === 'function') {
         productImages.slideTo(0);
       }
    }
  });
     });
}

}, 300);
// videos
document.querySelectorAll('.productSwiperPlay').forEach(playBtn => {
    playBtn.addEventListener('click', async function () {
        const video = this.querySelector('video');
        if (video) {
            if (this.classList.contains('active')) {
                await video.pause();
                this.classList.remove('active');
            } else {
                // Pause other videos before playing this one
                document.querySelectorAll('.productSwiperPlay video').forEach(v => {
                    v.pause();
                    v.closest('.productSwiperPlay')?.classList.remove('active');
                });

                await video.play();
                this.classList.add('active');
            }
        }
    });
});

/**************
 -- Tabs
 ***************/

// tab section
const productTabs = productPage.querySelector('#productTabs');

// each tab title, reveal and hide related info
productPage.querySelectorAll('.productTabsItemButton')?.forEach(button => {
    button.addEventListener('click', function () {

        //stop any videos
        if (productTabs?.querySelector('.productTabsItemVideo.active')) {
            productTabs.querySelectorAll('.productTabsItemVideo.active').forEach(el => {
                el.classList.remove('active');
                el.querySelector("video").pause();
            })
        }

        this.classList.toggle('active');
    })
})

// make sure there is at least one video
if (productTabs?.querySelector('.productTabsItemVideo')) {
// play videos on tabs
    productTabs.querySelectorAll('.productTabsItemVideo').forEach(el => {
        el.addEventListener('click', async function () {
            if (this.classList.contains('active')) {
                // pause this one
                this.classList.remove('active');
                await this.querySelector("video").pause();
            } else {
                // stop all videos
                if (productTabs.querySelector('.productTabsItemVideo.active')) {
                    productTabs.querySelectorAll('.productTabsItemVideo.active').forEach(el => {
                        el.classList.remove('active');
                        el.querySelector("video").pause();
                    })
                }
                // play this one
                this.classList.add('active');
                await this.querySelector("video").play();
            }
        })
    })
}

/**************
 -- Modals
 ***************/

// get BNPL modal
const bnplModal = document.querySelector('.bnpl');

// get Shipping Notice modal
const shippingNoticeModal = productPage.querySelector('#shippingNotice');

// get notification modal
const notificationModal = productPage.querySelector('#notification');

// BNPL Modal
productPage.querySelector('.productShippingItem.bnpl')?.addEventListener('click', () => {
    openModal(bnplModal);
})

// Shipping Notice Modal
productPage.querySelectorAll('.productShippingItem.shipping')?.forEach(el => {
    el.addEventListener('click', () => {
        openModal(shippingNoticeModal);
    })
})

// notification form submission
notificationModal?.querySelector('#notificationForm')?.addEventListener("submit", async function (e) {
    e.preventDefault();

    // confirm everything is provided
    let valid = true;
    this.querySelectorAll('[name]').forEach(function (element) {
        if (!element.value) {
            valid = false;
        }
    });

    if (!valid) {
        alert('Please make sure you fill out all fields.');
        return;
    }

    // validate email
    const emailCheck = validateEmail(this.querySelector('#email').value);
    if (!emailCheck) return;

    // start loading
    this.querySelector('button').classList.add('loading');

    // send KlaviyoBackInStockRequest
    sendKlaviyoBackInStockRequest(this.querySelector('#email').value, activeVariant.id);

    // check for newsletter opt in
    if (document.querySelector("#notificationLabelCheck").checked) {
        // add to newsletter
        fetch("https://api.maltertech.com/jadore/newsletter.php", {
            method: "POST",
            body: new URLSearchParams({
                email: this.querySelector('#email').value,
                store: Shopify.shop,
            })
        });
    }

    // end loading
    this.querySelector('button').classList.remove('loading');
    this.classList.add('success');

    // swap content and add close to new button
    this.closest('#notificationInner').classList.add('success');
    notificationModal.querySelector('#notificationBtnConfirmed')?.addEventListener('click', () => {
        notificationModal.close();
    })
})

/****************
 -- Update Product
 *****************/

productPage.querySelectorAll('input').forEach(input => {
    if (input.classList.contains('colorSelectorMobileVariantsItemInput')) return;
    if (input.classList.contains('productAddonsItemCheckInput')) return;
    input.addEventListener('change', () => {
        updateProduct()
            .catch(e => console.error(e));
    });
})

productPage.querySelectorAll('select').forEach(select => {
    if (select.classList.contains('productAddonsItemSelect')) return;
    if (select.classList.contains('productAddonsItemDialogSelect')) return;
    select.addEventListener('change', function () {
        // update the display to match select option
        document.querySelectorAll('.productOptionsItemValuesColorLayoutItem.active')?.forEach(item => item.classList.remove('active'));
        document.querySelector(`.productOptionsItemValuesColorLayoutItem[data-index="${this.selectedIndex}"]`)?.classList.add('active');
        // update the mobile text display
        productPage.querySelectorAll('.productOptionsItemValuesColorSelectMobileIndicatorItem')?.forEach(el => el.classList.remove('active'));
        productPage.querySelector(`.productOptionsItemValuesColorSelectMobileIndicatorItem[data-index="${this.selectedIndex}"]`)?.classList.add('active');
        updateProduct(this.selectedIndex)
            .catch(e => console.error(e));
    });
})

// variant color images
productPage.querySelectorAll('.productOptionsItemValuesColorLayoutItem')?.forEach(item => {
    item.addEventListener('click', function () {
        if (this.classList.contains('active')) return;
        // update the display color
        this.closest('.productOptionsItemValuesColorLayout')
            .querySelectorAll('.productOptionsItemValuesColorLayoutItem.active')
            .forEach(el => el.classList.remove('active'));
        this.classList.add('active');
        // update the select option - specifically target the hidden select
        const hiddenSelect = this.closest('.productOptionsItem').querySelector('select#hiddenSelect');
        if (hiddenSelect) {
            hiddenSelect.selectedIndex = this.dataset.index;
            hiddenSelect.dispatchEvent(new Event('change'));
        }
    });
})

// mobile select
productPage.querySelectorAll('.productOptionsItemValuesColorSelectMobileIndicator').forEach(el => {
    el.addEventListener('click', function () {
        openModal(productPage.querySelector('.colorSelectorMobile'));
    })
})

// mobile select
productPage.querySelectorAll('.colorSelectorMobileVariantsItemInput').forEach(input => {
    input.addEventListener('change', function () {
        // activate the hidden select option via the color displays
        productPage.querySelectorAll('.productOptionsItemValuesColorLayoutItem')?.forEach(el => el.classList.remove('active'));
        productPage.querySelector(`.productOptionsItemValuesColorLayoutItem[data-index="${this.dataset.index}"]`)?.click();
        // update the mobile text display
        productPage.querySelectorAll('.productOptionsItemValuesColorSelectMobileIndicatorItem')?.forEach(el => el.classList.remove('active'));
        productPage.querySelector(`.productOptionsItemValuesColorSelectMobileIndicatorItem[data-index="${this.dataset.index}"]`).classList.add('active');
        // close the dialog
        productPage.querySelector('.colorSelectorMobile').close();
    })
})

// mobile close
productPage.querySelectorAll('.colorSelectorMobileTopExit')?.forEach(exit => {
    exit.addEventListener('click', function () {
        this.closest('.colorSelectorMobile')?.close()
    })
})

const DEBUG_LOG = true;

function dbg(...args) {
  if (!DEBUG_LOG) return;
  console.log(...args);
}

function getActiveSwatch() {
  return productPage.querySelector(".productOptionsItemValuesColorLayoutItem.active");
}

function resolveColourFromUI() {
  const swatch = getActiveSwatch();
  if (swatch?.dataset?.color) return swatch.dataset.color.trim();

  const dropdownText = productPage
    .querySelector(".custom-dropdown .selected-option span")
    ?.textContent?.trim();

  if (dropdownText) return dropdownText;

  return null;
}

function resolveSizeFromUI() {
  const selects = Array.from(productPage.querySelectorAll("select")).filter((s) => {
    if (s.classList.contains("productAddonsItemSelect")) return false;
    if (s.classList.contains("productAddonsItemDialogSelect")) return false;
    if (s.id === "hiddenSelect") return false;
    return true;
  });

  for (const s of selects) {
    const v = (s.value || "").trim();
    if (v) return v;
  }

  const checked = Array.from(productPage.querySelectorAll("input:checked")).filter((i) => {
    if (i.classList.contains("colorSelectorMobileVariantsItemInput")) return false;
    if (i.classList.contains("productAddonsItemCheckInput")) return false;
    return true;
  });

  for (const i of checked) {
    const v = (i.value || "").trim();
    if (v) return v;
  }

  return null;
}

function resolveVariantFromSwatchAndSize() {
  const swatch = getActiveSwatch();
  const colour = resolveColourFromUI();
  const size = resolveSizeFromUI();

  dbg("🎨 resolveColourFromUI:", colour);
  dbg("📦 resolveSizeFromUI:", size);
  dbg("🟦 active swatch:", swatch ? swatch.dataset : null);

  const hiddenSelect = productPage.querySelector("select#hiddenSelect");
  let shopifyColourKey = null;

  if (hiddenSelect && swatch?.dataset?.index != null) {
    const idx = Number(swatch.dataset.index);
    const opt = hiddenSelect.options?.[idx];
    shopifyColourKey = (opt?.value || opt?.textContent || "").trim();
    dbg("🔑 shopifyColourKey from hiddenSelect:", shopifyColourKey);
  }

  if (!shopifyColourKey && colour) shopifyColourKey = colour;

  const candidates = product.variants.filter((v) => {
    const o1 = (v.option1 || v.options?.[0] || "").trim();
    return shopifyColourKey ? o1 === shopifyColourKey : true;
  });

  dbg(
    "🧩 candidate variants:",
    candidates.map((v) => ({ id: v.id, option1: v.option1, option2: v.option2, title: v.title }))
  );

  if (candidates.length === 0) return null;

  if (size) {
    const exact = candidates.find(
      (v) => String(v.option2 || v.options?.[1] || "").trim() === String(size).trim()
    );
    if (exact) return exact;
  }

  return candidates[0];
}

function setActiveVariantImagesByName(variantName) {
  if (!variantName) return;

  // Normalize for comparison (case-insensitive, trimmed)
  const norm = (s) => (s || "").toString().trim().toLowerCase();
  const target = norm(variantName);

  // Helper: activate matching image, or fall back to first image (prevents blank state)
  function activateMatchOrFirst(imageList) {
    let matched = null;
    imageList.forEach((img) => {
      if (matched) return;
      if (norm(img.getAttribute("alt")) === target) matched = img;
    });
    if (!matched && imageList.length > 0) matched = imageList[0];
    imageList.forEach((img) => {
      if (img === matched) img.classList.add("active");
      else img.classList.remove("active");
    });
  }

  // MAIN SWIPER images
  activateMatchOrFirst(document.querySelectorAll(".productSwiperImageVariant"));

  // THUMBNAILS
  activateMatchOrFirst(document.querySelectorAll("#productThumbnails img.productThumbnail.variant"));
}

async function updateProduct(index = null) {
  if (DEBUG_LOG) {
    console.group("🔁 updateProduct");
    console.log("passed index:", index);
    console.log("current URL variant:", new URL(window.location.href).searchParams.get("variant"));
  }

  let nextVariant = resolveVariantFromSwatchAndSize();

  if (nextVariant) {
    activeVariant = nextVariant;
    dbg("✅ resolved activeVariant from swatch+size:", {
      id: activeVariant.id,
      title: activeVariant.title,
      option1: activeVariant.option1,
      option2: activeVariant.option2,
    });
  } else {
    dbg("⚠️ swatch+size resolve failed, falling back to old options matching");

    if (product.variants.length === 1) {
      activeVariant = product.variants[0];
    } else {
      const options = [];

      productPage.querySelectorAll("select")?.forEach((select) => {
        if (select.classList.contains("productAddonsItemSelect")) return;
        if (select.classList.contains("productAddonsItemDialogSelect")) return;
        options.push(select.value);
      });

      productPage.querySelectorAll("input:checked")?.forEach((input) => {
        if (input.classList.contains("colorSelectorMobileVariantsItemInput")) return;
        if (input.classList.contains("productAddonsItemCheckInput")) return;
        options.push(input.value);
      });

      dbg("resolved UI options:", options);

      activeVariant = product.variants.find((variant) => {
        return (
          JSON.stringify(variant.options) === JSON.stringify(options) ||
          JSON.stringify(variant.options) === JSON.stringify([...options].reverse())
        );
      });
    }

    if (!activeVariant) {
      if (index !== null && product.variants[index]) {
        activeVariant = product.variants[index];
      } else {
        activeVariant = product.variants.find((v) => v.available) || product.variants[0];
      }
    }
  }

  // reset swiper position if it exists (prevents “blank slide”)
  if (typeof productImages !== "undefined" && productImages && typeof productImages.slideTo === "function") {
    productImages.slideTo(0);
  }

  // overlay image (your existing behavior)
  const colorSelect = productPage.querySelector(".productOptionsItemValuesColorLayoutItem.active");
  if (colorSelect) {
    if (colorSelect.dataset.image !== "https://cdn.shopify.com/s/files/1/2597/5920/?width=800") {
      const overlay = document.querySelector("#productSwiperImageOverlay");
      overlay.src = colorSelect.dataset.image;
      overlay.classList.add("active");
    } else {
      document.querySelector("#productSwiperImageOverlay")?.classList.remove("active");
    }
  }

  // price
  const compareEl = productPage.querySelector("#productCompare");
  const realEl = productPage.querySelector("#productPrice");

  if (activeVariant.compare_at_price > activeVariant.price) {
    compareEl.textContent = price(activeVariant.compare_at_price * quantity, false);
  } else {
    compareEl.textContent = "";
  }
  realEl.textContent = price(activeVariant.price * quantity, false);

  if (document.querySelector("square-placement")) {
    document.querySelector("square-placement").dataset.amount = (activeVariant.price * quantity / 100).toString();
  }

  // ATC + optional price display
  if (activeVariant.available) {
    productATCButton.classList.remove("notification");
    productPage.querySelector("#productATCText").textContent = "Add To Cart";
    productPage.querySelector("#productPriceDisplay")?.style && (productPage.querySelector("#productPriceDisplay").style.display = "block");
  } else {
    productATCButton.classList.add("notification");
    const soldOutText =
      typeof productATCTextSoldout !== "undefined" ? productATCTextSoldout : "Sold Out - Notify Me";
    productATCButton.querySelector("#productATCText").textContent = soldOutText;
    productPage.querySelector("#productPriceDisplay")?.style && (productPage.querySelector("#productPriceDisplay").style.display = "none");
  }

  // URL update only if changed
  const url = new URL(window.location.href);
  const prev = url.searchParams.get("variant");
  const next = String(activeVariant.id);

  if (prev !== next) {
    url.searchParams.set("variant", next);
    window.history.replaceState({}, "", url);
  }

  // activate correct images by name
  const variantNameForImages =
    productPage.querySelector(".custom-dropdown .selected-option span")?.textContent?.trim() || activeVariant.option1;

  setActiveVariantImagesByName(variantNameForImages);

  if (DEBUG_LOG) console.groupEnd();
}

// keep ONLY ONE of these in the whole file
document.querySelector("#productSwiperImageOverlay")?.addEventListener("click", function () {
  this.classList.remove("active");
});

// initial call (keep it delayed so Swiper exists if needed)
setTimeout(() => {
  updateProduct().catch((e) => console.error(e));
}, 400);


// incremental and decremental buttons
productPage.querySelector('.productVariantSpecAmountSelector').addEventListener('click', function (e) {
    // prevent bubbling to parent
    e.stopPropagation();

    // if minus clicked subtract from quantity
    if (e.target.classList.contains('productVariantSpecAmountSelectorLess')) {
        // can not go below 1
        if (quantity === 1) return
        // subtract from amount and display
        quantity--;
    } else if (e.target.classList.contains('productVariantSpecAmountSelectorMore')) {
        // add to amount and display
        quantity++;
    } else {
        return;
    }
    // update only the quantity display, don't re-evaluate product state
    this.querySelector('.productVariantSpecAmountSelectorDisplay').textContent = quantity.toString();

    // Update payment amount if square-placement element exists
    if (document.querySelector('square-placement') && activeVariant) {
        document.querySelector('square-placement').dataset.amount = (activeVariant.price * quantity / 100).toString();
    }

    // Update displayed prices in real-time with quantity changes
    if (activeVariant && activeVariant.price) {

        // Update main price
        const realEl = productPage.querySelector("#productPrice") ||
                       productPage.querySelector(".product-price") ||
                       productPage.querySelector("[data-price]") ||
                       productPage.querySelector(".price") ||
                       productPage.querySelector("span[class*='price']");

        if (realEl) {
            realEl.textContent = price(activeVariant.price * quantity, false);
        }

        // Update compare price if it exists
        const compareEl = productPage.querySelector("#productCompare") ||
                         productPage.querySelector(".product-compare-price") ||
                         productPage.querySelector("[data-compare-price]");

        if (compareEl && activeVariant.compare_at_price > activeVariant.price) {
            compareEl.textContent = price(activeVariant.compare_at_price * quantity, false);
        }
    }
})

/*******************
 -- Product Addons --
 ********************/

productPage.querySelectorAll('.productAddonsItemDialogOpen')?.forEach(button => {
    button.addEventListener('click', function () {
        openModal(this.closest('.productAddonsItem').querySelector('.productAddonsItemDialog'));
    })
})

productPage.querySelectorAll('.productAddonsItemDialogExit')?.forEach(exit => {
    exit.addEventListener('click', function () {
        this.closest('.productAddonsItemDialog').close();
    })
})

productPage.querySelectorAll('.productAddonsItemSelect')?.forEach(select => {
    select.addEventListener('change', function () {
        addOnImages(this);
        this.closest('.productAddonsItem').querySelector('.productAddonsItemDialogSelect').selectedIndex = this.selectedIndex;
        if (this.value === "unavailable") {
            this.closest('.productAddonsItem').querySelector('.productAddonsItemCheckInput').checked = false;
        }
    })
})

productPage.querySelectorAll('.productAddonsItemDialogSelect')?.forEach(select => {
    select.addEventListener('change', function () {
        addOnImages(this);
        this.closest('.productAddonsItem').querySelector('.productAddonsItemSelect').selectedIndex = this.selectedIndex;
    })
})

function addOnImages(element) {
    const parent = element.closest('.productAddonsItem');
    // item change
    parent.querySelector('.productAddonsItemImage.active').classList.remove('active');
    parent.querySelector(`.productAddonsItemImage[data-index="${element.selectedIndex}"]`).classList.add('active');
    // dialog change
    parent.querySelector('.productAddonsItemDialogImage.active').classList.remove('active');
    parent.querySelector(`.productAddonsItemDialogImage[data-index="${element.selectedIndex}"]`).classList.add('active');
    // uncheck if unavailable
    if (element.value === "unavailable") {
        parent.querySelector('.productAddonsItemCheckInput').checked = false;
    }
}

productPage.querySelectorAll('.productAddonsItemCheckInput')?.forEach(input => {
    input.addEventListener('change', function () {
        if (this.closest('.productAddonsItem').querySelector('.productAddonsItemSelect').value === "unavailable") {
            this.checked = false;
        }
    })
})

/*************
 Product ATC
 ************/

// main product
productATCButton.addEventListener("click", async function () {

    // if an inactive variant is selected, interrupt and open notification form
    if (this.classList.contains('notification')) {
        // open notification Modal
        openModal(notificationModal);
        return;
    }

    let formData;

    // add loading animation
    this.classList.add("loading");

    formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // addons
    productPage.querySelectorAll('.productAddonsItemCheckInput:checked')?.forEach(input => {
        formData.items.push({
            quantity: 1,
            id: +input.closest('.productAddonsItem').querySelector('.productAddonsItemSelect').value,
        })
    })

    // add product
    try {
        await addProduct(formData);
    } catch (e) {
        // failed to atc
        console.error(e);
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});

/******************
 -- Recently Viewed
 ******************/

// pull recently viewed from local storage and add unless already there
let recentlyViewedStorage = localStorage.getItem("recently-viewed")
// if there is no recently-viewed, create one
const recentlyViewed = recentlyViewedStorage ? JSON.parse(recentlyViewedStorage) : [];
// check if product is already added
const filteredRecent = recentlyViewed.filter(item => item.title !== product.title)
if (filteredRecent.length === recentlyViewed.length) {
    // if not add
    recentlyViewed.push(product)
    // keeping it at the last four viewed
    while (recentlyViewed.length > 4) {
        recentlyViewed.shift()
    }
    localStorage.setItem("recently-viewed", JSON.stringify(recentlyViewed))
}
} // End of productPage check
